export default __webpack_public_path__ + "static/media/AddIcon.e6dedc8b.svg";